var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"back-link",style:({
        color: _vm.colors.secondary
    }),attrs:{"to":_vm.backLink + _vm.workspaceId}},[_c('div',{staticClass:"arrow-left",style:({
            'border-right': ("6px solid " + (_vm.colors.secondary))
        })}),_c('span',[_vm._v(_vm._s(_vm.$t("components.InputDefault.backOption")))])])}
var staticRenderFns = []

export { render, staticRenderFns }